<template>
  <div>
    <layout :top="-40">
      <!--<Search slot="header-bar" show-action placeholder="输入告警名称进行搜索" v-model="searchInput" @search="onRefresh">-->
      <!--<div-->
      <!--style="display: flex;width: 100%;justify-content: center;align-item: center"-->
      <!--@click="qrScan"-->
      <!--slot="action"-->
      <!--&gt;-->
      <!--<van-icon size="20px" name="scan"/>-->
      <!--</div>-->
      <!--&lt;!&ndash;<div slot="left-icon">&ndash;&gt;-->
      <!--&lt;!&ndash;<span @click="openSearchPanel">高级</span>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--</Search>-->
      <PullRefresh v-model="isReFresh" @refresh="onRefresh">
        <List
          style="padding: 5px 12px"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          loading-text="拼命加载中..."
          @load="onLoad"
          :offset="50"
          :immediate-check="true"
        >
          <AlarmItem
            v-for="item in alarmRealTimeList"
            type="history"
            :key="item.id"
            :info="item"
          />
        </List>
      </PullRefresh>
    </layout>
    <Popup v-model="show" position="top">
      <Field
        v-model="search.unitName"
        label="所在单位"
        readonly
        clearable
        placeholder="请选择所在单位"
        right-icon="arrow-down"
        @click="unitPanel = true"
      />
      <Field
        clearable
        v-model="typeName"
        label="告警类型"
        placeholder="请选择告警类型"
        readonly
        right-icon="arrow-down"
        @click="selectShow = true"
        :rules="[{ required: true, message: '告警类型必选' }]"
      />
      <Field
        v-model="search.startTime"
        label="开始时间"
        readonly
        placeholder="请选择开始时间"
        right-icon="arrow-down"
        @click="showStartTimePanel(true)"
      />
      <Field
        v-model="search.endTime"
        label="结束时间"
        readonly
        placeholder="请选择结束时间"
        right-icon="arrow-down"
        @click="showEndTimePanel(true)"
      />
      <Button
        type="info"
        block
        style="width: 90% ; margin: 10px auto;"
        @click="onRefresh"
        >查询</Button
      >
    </Popup>
    <SelectTreePopup
      :show="unitPanel"
      :defaultSelected="
        search.unitId ? { id: search.unitId, name: search.unitName } : {}
      "
      :treeData="unitTree"
      :defaultTitle="search.unitName || '选择单位'"
      @ok="onUnitOk"
      @cancel="unitPanel = false"
    />
    <SelectDict
      :showAll="true"
      dictKey="EVENT_TYPE"
      :show="selectShow"
      @cancel="selectShow = false"
      @ok="onTypeOk"
    />
    <DateTimePopup
      type="start"
      :max="search.endTime"
      :time="search.startTime"
      :timePanel="startTimePanel"
      @cancel="showStartTimePanel(false)"
      @ok="changeStartTime"
    />
    <DateTimePopup
      type="end"
      :min="search.startTime"
      :time="search.endTime"
      :timePanel="endTimePanel"
      @cancel="showEndTimePanel(false)"
      @ok="changeEndTime"
    />
  </div>
</template>

<script>
import { Button, Field, List, Popup, PullRefresh, Search } from "vant";
import wx from "weixin-js-sdk";
import Select from "@/components/Select";
import AlarmItem from "../../alarm/components/AlarmItem";
import SelectDict from "@/components/SelectPopup/SelectDict";
import DateTimePopup from "@/components/DateTimePopup";
import { mapGetters } from "vuex";
import { dateFormat } from "@/utils/tool";
import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup";

export default {
  components: {
    Search,
    List,
    Select,
    PullRefresh,
    AlarmItem,
    SelectDict,
    Popup,
    Field,
    Button,
    DateTimePopup,
    SelectTreePopup,
  },
  props: {},
  data() {
    return {
      deviceId: this.$route.params.id,
      alarmRealTimeList: [],
      searchInput: null,
      deviceSn: null,
      loading: false,
      isReFresh: false,
      finished: false,
      show: false,
      startTimePanel: false,
      endTimePanel: false,
      selectShow: false,
      unitPanel: false,
      typeName: null,
      search: {
        unitName: null,
        unitId: null,
        startTime: "",
        endTime: "",
        eventType: null,
      },
    };
  },
  computed: {
    ...mapGetters({ unitTree: "global/unitTree" }),
  },
  created() {
    const { unitOrOrgan } = this.$default;
    this.search.unitName = unitOrOrgan.name;
    this.search.unitId = unitOrOrgan.id;
  },
  mounted() {
    this.initDate();
  },
  methods: {
    onUnitOk(data) {
      this.unitPanel = false;
      this.search.unitId = data.id;
      this.search.unitName = data.name;
    },
    openSearchPanel() {
      this.show = true;
    },
    initDate() {
      const endTime = new Date();
      const startTime = new Date(endTime.getTime() - 1000 * 60 * 60 * 24 * 7);
      this.search.startTime = dateFormat("YYYY-MM-DD HH:mm:ss", startTime);
      this.search.endTime = dateFormat("YYYY-MM-DD HH:mm:ss", endTime);
    },
    showStartTimePanel(show) {
      this.startTimePanel = show;
    },
    changeStartTime(value) {
      this.search.startTime = value;
      this.startTimePanel = false;
    },
    showEndTimePanel(show) {
      this.endTimePanel = show;
    },
    changeEndTime(value) {
      this.search.endTime = value;
      this.endTimePanel = false;
    },
    onTypeOk(data) {
      this.typeName = data.codeName;
      if (data.code == "All") this.search.eventType = null;
      else this.search.eventType = data.code;
      this.selectShow = false;
    },

    onLoad(isPullRefresh) {
      this.$http.tokiot.enterprise.alarm
        .list({
          deviceId: this.deviceId,
          // eventType: this.search.eventType,
          // startTime: this.search.startTime,
          // endTime: this.search.endTime,
          // unitId: this.search.unitId,
          size: 20,
          page: this.alarmRealTimeList.length / 20 + 1,
        })
        .then((res) => {
          if (res) {
            res.rows.map((item) => (item.params = JSON.parse(item.params)));
            this.alarmRealTimeList.push(...res.rows);
            this.loading = false;
            if (isPullRefresh) this.isReFresh = false;
            if (this.alarmRealTimeList.length >= res.total) {
              this.finished = true;
            }
          }
        });
    },
    onRefresh() {
      this.show = false;
      this.isReFresh = true;
      this.alarmRealTimeList = [];
      this.onLoad(true);
    },
    qrScan() {
      const This = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let index = res.resultStr.indexOf(`CODE_128,`);
          if (index === -1) {
            This.device.sn = res.resultStr;
            this.onRefresh();
          } else {
            let len = res.resultStr.length;
            This.device.sn = res.resultStr.slice(index + 9, len - 1);
            this.onRefresh();
          }
        },
      });
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped></style>